import styled from "styled-components";
import { getDeclarations, getBorderLayerDeclarations } from "./helpers";
import { getTransparentLayerDeclarations } from "../common/helpers";
const sizeMap = (gap) => ({
    small: {
        s: "1 100%",
    },
    medium: {
        s: `0 calc(50% - ${gap || '0px'})`,
    },
    large: {
        s: `0 calc(33.33% - ${gap || '0px'})`,
    },
});
export const HeadlineWithShortTeaserContainer = styled.div `
  &&& {
    ${({ size, gap }) => `flex: ${sizeMap(gap).small[size]};`}
    ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, customBackground)}
    & .gdds-border-layer {
      ${({ theme, backgroundType, customBackground }) => getBorderLayerDeclarations(theme, backgroundType, undefined, !!customBackground)}
    }

    position: relative;
    min-height: 13.5rem;
    box-sizing: border-box;
    padding: 1.5rem 1.5rem 1rem 1.5rem;
    outline: none;

    & .image-container {
      transition: all 0.25s ease-in-out;
    }

    &:hover {
      ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, customBackground)}
      & .gdds-transparent-layer {
        ${({ theme, backgroundType }) => getTransparentLayerDeclarations(theme, backgroundType, "hovered")}
      }
      & .gdds-border-layer {
        ${({ theme, backgroundType, customBackground }) => getBorderLayerDeclarations(theme, backgroundType, "hovered", !!customBackground)}
      }
      & .image-container {
        transform: scale(1);
      }
    }

    &:focus {
      ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, customBackground)}

      & .gdds-border-layer {
        ${({ theme, backgroundType, focused, customBackground }) => getBorderLayerDeclarations(theme, backgroundType, focused ? "focused" : undefined, !!customBackground)}
      }
    }

    &:active:is(:focus) {
      ${({ theme, backgroundType, customBackground }) => getDeclarations(theme, backgroundType, customBackground)}

      & .gdds-border-layer {
        ${({ theme, backgroundType, focused, customBackground }) => getBorderLayerDeclarations(theme, backgroundType, !focused ? "active" : undefined, !!customBackground)}
      }
    }

    @media ${({ theme }) => theme.device.medium} {
      ${({ size, gap }) => `flex: ${sizeMap(gap).medium[size]};`}
      padding: 2rem;
      ${({ height }) => `height: ${height}px;`}
    }

    @media ${({ theme }) => theme.device.large} {
      ${({ size, gap }) => `flex: ${sizeMap(gap).large[size]};`}
    }

    @media ${({ theme }) => theme.device.xlarge} {
      max-height: 21.75rem;
    }
  }
`;
